import { Inject, Injectable } from '@angular/core'
import { SiteContextParamsService, SiteContextUrlSerializer } from '@spartacus/core'
import { EbCountryService } from './eb-country.service'
import { EbLanguageService } from './eb-language.service'

/**
 * Values of the site context parameters encoded in the URL.
 */
export interface SiteContextUrlParams {
  [name: string]: string
}
@Injectable()
export class EbSiteContextUrlSerializer extends SiteContextUrlSerializer {
  constructor(
    siteContextParams: SiteContextParamsService,
    protected ebSiteContextParams: SiteContextParamsService,
    protected countryService: EbCountryService,
    protected ebLanguageService: EbLanguageService,
    @Inject('Window') protected window
  ) {
    super(siteContextParams)
  }

  private static hasUrlValidCountryLanguagePattern(countryLanguagePattern: string): boolean {
    return (
      /^[A-Z]{2}\/[a-z]{2}$/.test(countryLanguagePattern) ||
      /^\/[A-Z]{2}\/[a-z]{2}$/.test(countryLanguagePattern) ||
      /^\/[A-Z]{2}\/[a-z]{2}\//.test(countryLanguagePattern) ||
      /^\/[A-Z]{2}\/[a-z]{2}\?/.test(countryLanguagePattern)
    )
  }

  private static replaceUrl(url: string, contextRoutePart: string) {
    return EbSiteContextUrlSerializer.hasUrlValidCountryLanguagePattern(url)
      ? url.replace(/^\/[A-Z]{2}\/[a-z]{2}/, `${contextRoutePart}`)
      : `/${contextRoutePart}${url}`
  }

  /**
   * Prepends the current values of the site context parameters to the given URL.
   * Handles the different cases of country language pattern in url
   */
  protected urlIncludeContextParameters(url: string, params: SiteContextUrlParams): string {
    const contextRoutePart = this.urlEncodingParameters
      .map(param => {
        return params[param] ? params[param] : this.ebSiteContextParams.getValue(param)
      })
      .join('/')
    const countryInUrl = (this.countryService.getCountryFromUrl() || '').toUpperCase()
    const languageInUrl = (this.ebLanguageService.getLanguageFromUrlOrStorage() || '').toLowerCase()
    const countryLanguageUrlPattern = `${countryInUrl}/${languageInUrl}`

    if (
      contextRoutePart &&
      EbSiteContextUrlSerializer.hasUrlValidCountryLanguagePattern(contextRoutePart) &&
      EbSiteContextUrlSerializer.hasUrlValidCountryLanguagePattern(countryLanguageUrlPattern)
    ) {
      return url.includes(contextRoutePart)
        ? url
        : EbSiteContextUrlSerializer.replaceUrl(url, contextRoutePart)
    } else if (
      !EbSiteContextUrlSerializer.hasUrlValidCountryLanguagePattern(contextRoutePart) &&
      url.length > 0
    ) {
      this.window.open(
        `/${this.countryService.checkForStoredCountryOrFallback()}/${this.ebLanguageService.checkForStoredLanguageOrFallback()}${url}`,
        '_self'
      )
    } else {
      this.window.open(
        `/${this.countryService.checkForStoredCountryOrFallback()}/${this.ebLanguageService.checkForStoredLanguageOrFallback()}`,
        '_self'
      )
    }
  }
}
